export default __webpack_public_path__ + "static/media/feature4_4.80117c40.png";